var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenPlaneUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.672,
    height: 11.455,
    viewBox: "0 0 22.672 11.455",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Page_1_Copy_2",
    "data-name": "Page 1 Copy 2",
    d: "M.275,4.959l1.549-.722a.476.476,0,0,1,.45.026l3.04,1.868a.476.476,0,0,0,.464.019l9.412-4.774.033-.019A9.722,9.722,0,0,1,20.674.025s2.218-.236,1.98,1.348C22.424,2.9,17.506,5,16,5.442a.463.463,0,0,0-.262.2l-3.07,4.86a.474.474,0,0,1-.228.189l-1.861.731a.475.475,0,0,1-.648-.414L9.776,8.435a.475.475,0,0,0-.645-.415A24.816,24.816,0,0,1,1.259,9.753c-.341,0,.382-.859.815-1.342a.474.474,0,0,0-.009-.643L.13,5.716a.475.475,0,0,1,.145-.757Z",
    fill: "#05ce78"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenPlaneUp);
export default __webpack_public_path__ + "static/media/green-plane-up.6b7091eee96950511e88ffe49f8f7537.svg";
export { ForwardRef as ReactComponent };